<template>
  <div>
    <!-- <div class="container">
        <div class="announcement-banner">
          <h2>AgriVitech rejoint Akanea du Groupe Isagri</h2>
          <p>Nous sommes fiers de vous annoncer qu'AgriVitech a été rachetée par la société <a href="https://akanea.com/" target="_blank">Akanea Développement</a> du <a href="https://www.isagri.com/" target="_blank">Groupe Isagri</a>. Toute l'équipe est fière de cette nouvelle étape qui portera la solution Fleet aux plus grands acteurs du monde du transport.</p>
          <p><a href="https://akanea.com/integration-fleet-by-agrivitech/" target="_blank" class="press-release-link">Lire le communiqué de presse</a></p>
        </div>
    </div> -->
    <Solutions/>
    <MailjetNewsLetter/>
  </div>
</template>

<script>
import Solutions from '../components/Solutions'
import MailjetNewsLetter from '../components/MailjetNewsLetter'

export default {
  name: 'Homepage',
  components: {
    Solutions,
    MailjetNewsLetter
  },
  props: {
  },
  created(){
    // this.$matomo && this.$matomo.trackPageView()
    // console.log(this.$matomo)
  },
  mounted(){
    /*var _paq = window._paq = window._paq || [];
    window.addEventListener('hashchange', function() {
        _paq.push(['trackPageView']);
    });*/
    // this.$matomo && this.$matomo.trackPageView()
  }  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  .announcement-banner {
    background-color: var(--mainBlue);
    color: white;
    padding: 2rem;
    border-radius: 10px;
    margin-top: 2rem;
    margin-bottom: 2rem;
    text-align: center;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    
    h2 {
      font-size: 1.8rem;
      font-weight: 600;
      margin-bottom: 1rem;
    }
    
    p {
      font-size: 1.1rem;
      margin-bottom: 1rem;
    }
    
    a {
      color: var(--mainGreen);
      font-weight: 600;
      text-decoration: none;
      
      &:hover {
        text-decoration: underline;
      }
    }
    
    .press-release-link {
      display: inline-block;
      background-color: var(--mainGreen);
      color: white;
      padding: 0.5rem 1rem;
      border-radius: 5px;
      margin-top: 0.5rem;
      
      &:hover {
        background-color: darken(#17a673, 10%);
        text-decoration: none;
      }
    }
  }

  header {
  position: relative;
  top: 0;
  background-color: black;
  height: 75vh;
  min-height: 25rem;
  width: 100%;
  overflow: hidden;
  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: black;
    opacity: 0.5;
    z-index: 1;
  }
  .container {
    position: relative;
    z-index: 2;
  }
}

header {
  video {
    position: absolute;
    top: 50%;
    left: 50%;
    min-width: 100vh;
    min-height: 100%;
    width: auto;
    height: auto;
    z-index: 0;
    -ms-transform: translateX(-50%) translateY(-50%);
    -moz-transform: translateX(-50%) translateY(-50%);
    -webkit-transform: translateX(-50%) translateY(-50%);
    transform: translateX(-50%) translateY(-50%);
  }
}

  

  .solution-preview{
    margin: 100px 0px;
    img{
      padding: 20px;
    }
  }
  .title-block {
      font-size: 45px;
      margin-bottom: 20px;
    }
  .dark-block{
    min-height: 200px;
    color: white;
    font-size: 20px;
    background-color: var(--mainBlue);
    padding: 20px;
    border-radius: 18px;
    text-align: left;
  }
  .light-block{
    min-height: 200px;
    font-size: 20px;
    padding: 20px;
    border-radius: 18px;
    text-align: left;
  }

  .contact-block {
    color: white;
    font-weight: 600;
    font-size: 25px;
    background-color: var(--mainBlue);
    padding: 20px;
    border-radius: 18px;
    text-align: center;
    .tagline{
      padding: 50px 0px 20px 0px;
    }
    .styledInput{
      margin: auto;
      border-radius: 20px;
      max-width: 300px;
      margin-bottom: 50px;
      .input-group-append{
        max-width: 300px;
        
        .btn-input{
        background-color: var(--mainGreen);
        color: white;
      }
      }
    }
  }
  .clients-logo{
    .logoContainer{
      background-color: #f9f9f9;
      padding: 5px;
      border-radius: 25px;
      border: white 10px solid;
      img{
        margin-top: 15px;
        margin-bottom: 5px;
        filter: grayscale(100%);
      }
      &:hover {
        img{
          filter: none;
        }
      }
    }
  }

</style>
